import { render, staticRenderFns } from "./rewards.vue?vue&type=template&id=2a70fcbb&scoped=true&"
import script from "./rewards.vue?vue&type=script&lang=js&"
export * from "./rewards.vue?vue&type=script&lang=js&"
import style0 from "./rewards.vue?vue&type=style&index=0&id=2a70fcbb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a70fcbb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a70fcbb')) {
      api.createRecord('2a70fcbb', component.options)
    } else {
      api.reload('2a70fcbb', component.options)
    }
    module.hot.accept("./rewards.vue?vue&type=template&id=2a70fcbb&scoped=true&", function () {
      api.rerender('2a70fcbb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pages/rewards.vue"
export default component.exports